import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  bottom?: boolean;
  top?: boolean;
}

export function SafeArea({ children, bottom = true, top = false }: Props) {
  return (
    <div className={[top ? "pt-12" : "", bottom ? "pb-20" : ""].filter(Boolean).join(" ") || undefined}>
      {children}
    </div>
  );
}
